import React from 'react';
import { useSelector } from 'react-redux';
import SocialShareModalAICaptionsField from 'containers/SocialShareModal/SocialShareModalAICaptionsField';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import { useSocialShareModal } from 'containers/SocialShareModal/SocialShareModalContext';
import { facebookPostingSelector } from 'redux/modules/social';
import { makeSocialPostLengthCounter } from 'utils/string';
import { FACEBOOK_MAX_DESCRIPTION_CHARS } from './constants';

const zeroSocialPostLengthCounter = makeSocialPostLengthCounter(0);

export type FacebookPostComposerStepProps = {};

const FacebookPostComposerStep: React.FC<FacebookPostComposerStepProps> = () => {
  const isPosting = useSelector(facebookPostingSelector);

  const { description, setDescription } = useSocialShareModal();

  return (
    <SocialShareModalBody loadingTitle="Posting Video" isLoading={isPosting}>
      <SocialShareModalAICaptionsField
        inputProps={{
          value: description,
          maxChars: FACEBOOK_MAX_DESCRIPTION_CHARS,
          countRemaining: zeroSocialPostLengthCounter,
          onChange: setDescription,
        }}
      />
    </SocialShareModalBody>
  );
};

export default FacebookPostComposerStep;
